import _ from "underscore";

import template from '../templates/editor.jst';

import HeaderContent from './header_content';
import ItemContent from './item_content';

import AddListView from 'shared/components/add_list';
import Select from 'shared/select';

import View from "backdraft-app/src/view";

const MAX_KEYWORDS = 20;

export default class KeywordsEditor extends View {
  initialize(options) {
    super.initialize(options);

    options = _.defaults(options || {}, { editable: true });
    this.editable = options.editable;

    this.listenTo(this.collection, "add remove", this._adjustControls);
  }

  render() {
    this.$el.html(template({ MAX_KEYWORDS }));
    this._adjustControls();

    const list = new AddListView({
      collection: this.collection,
      headerContentView: HeaderContent,
      itemContentView: ItemContent,
      readOnly: !this.editable,
      createEmptyItem() {
        return { name: "", speaker: "Agent or Caller" };
      }
    });

    this.child("list", list);
    this.$("[data-mount='keywords-list']").html(list.render().$el);

    // make sure we run our callbacks after the list plugin
    this.listenTo(this.collection, "add remove reset", this._adjustControls);
    return this;
  }

  _adjustControls() {
    this.$el.toggleClass("max-keywords", this.collection.length === MAX_KEYWORDS);
    Select.convertAll(this.$el);
  }

  close() {
    Select.closeAll(this.$el);

    super.close();
  }
}
